// pitstopTargetBus — Übergabe vom Pit-Stop-Finder an den Planer.
//
// Der Pit-Stop-Finder wählt einen POI voraus und will eine Route DORTHIN.
// Statt das Routing zu duplizieren, übergeben wir Start (aktuelle — ggf.
// simulierte — Position) + Ziel (POI) an CreateCustomPage, das die Pins setzt
// und die bestehende Routing-Maschinerie nutzt. Start wird explizit mitgegeben
// (nicht via GPS-Button), damit der Test-Modus mit simulierter Position klappt.

export interface PitstopTarget {
  /** [lon, lat] — aktuelle/simulierte Position. */
  start: [number, number];
  /** [lon, lat] — Routenziel. Ohne `via` der POI; MIT `via` der Wiederein-
   *  stiegspunkt auf die Rennstrecke (Rundfahrt zum POI und zurück). */
  end: [number, number];
  /** [lon, lat][] — geordnete Zwischenstopps (z.B. [Ausstieg, POI]) für die
   *  Rundfahrt zurück zur Rennstrecke. Undefined/leer = einfacher Weg zum POI. */
  via?: Array<[number, number]>;
  /** Anzeigename des Ziels (POI-Name oder Kategorie). */
  endName?: string;
  /** [lat, lon, ele?][] — die aktive Rennstrecke, mitgegeben damit der Planer
   *  sie einblenden kann (routeBus wird beim Verlassen der Karte geleert). */
  raceRoute?: Array<[number, number, number?]>;
}

type Listener = (t: PitstopTarget | null) => void;

class PitstopTargetBus {
  private current: PitstopTarget | null = null;
  private readonly listeners = new Set<Listener>();

  peek(): PitstopTarget | null {
    return this.current;
  }
  consume(): PitstopTarget | null {
    const t = this.current;
    this.current = null;
    return t;
  }
  publish(t: PitstopTarget): void {
    this.current = t;
    for (const l of this.listeners) l(t);
  }
  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }
}

export const pitstopTargetBus = new PitstopTargetBus();
